module.exports = __webpack_public_path__ + "static/img/2.b08227d2.jpg";